<div class="modal-backdrop" (click)="onClose()"></div>
<div class="modal-container">
	<section class="d-f fd-c jc-sb md">
		<div class="pt-xxxs pb-xxxs pr-xxs pl-xxs d-f jc-sb ai-c md__header">
			<h2>Cancelar Transferência</h2>
			<button mat-icon-button aria-label="Close modal" (click)="onClose()">
				<mat-icon svgIcon="sanus-closeb"></mat-icon>
			</button>
		</div>

		<div class="mt-xxs mb-xxs d-f fd-c jc-fs oy-a md__body no-margins">
			<div class="w-100 h-100 container">
				<div class="text-center mt-xs">
					<p class="confirmation-text mb-xxs">
						Tem certeza de que deseja cancelar a transferência agendada para
						<strong>{{ transfer?.toOrganization?.name_secondary }}</strong>
						?
					</p>

					<div class="transfer-details mt-xxs">
						<div class="detail-row">
							<span class="detail-label">Organização:</span>
							<span class="detail-value">
								{{ transfer?.toOrganization?.name_secondary }}
							</span>
						</div>
						<div class="detail-row">
							<span class="detail-label">Data agendada:</span>
							<span class="detail-value">
								{{ transfer?.scheduledDate | date: 'dd/MM/yyyy' }}
							</span>
						</div>
						<div class="detail-row">
							<span class="detail-label">Beneficiários:</span>
							<span class="detail-value">{{ getBeneficiariesText() }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="pt-xxxs pb-xxxs pr-xxs pl-xxs d-f ai-c jc-fe fixed-footer md__footer"
		>
			<button
				class="p-quark mr-xxs"
				mat-stroked-button
				color="primary"
				(click)="onClose()"
			>
				Manter Transferência
			</button>
			<button
				class="p-quark"
				mat-flat-button
				color="warn"
				(click)="onConfirm()"
			>
				<mat-icon class="mr-nano">cancel</mat-icon>
				Cancelar Transferência
			</button>
		</div>
	</section>
</div>
